import { mutationRemove, type RemoveHookResponse } from '../hooks'
import { useLocationCache } from '../location'
import { useTantalimMutation } from '../mutation'
import { useEventCache } from './cache'
import {
  toResponseError,
  type LocationId,
  type CalendarEventRemoveInput,
  type CalendarEventRemoveSuccess,
} from '@terros/common'

export function useRemoveCalendarEvent(locationId?: LocationId): RemoveHookResponse<CalendarEventRemoveInput> {
  const cache = useEventCache()
  const locationCache = useLocationCache()

  const mutation = useTantalimMutation<CalendarEventRemoveInput, CalendarEventRemoveSuccess>({
    url: '/calendar/event/remove',
  })

  async function remove(input: CalendarEventRemoveInput): Promise<void> {
    try {
      await mutation.mutateAsync(input)
      cache.removeItem(input.eventId)
      if (locationId) locationCache.clearItem(locationId)
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationRemove(mutation, remove)
}
